import React from 'react';

class ProjectBox extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          title: this.props.numBoxes, 
          description: this.props.description,
          titleLink: this.props.titleLink,
          boxLink: this.props.boxLink,
          hoverColor: this.props.hoverColor,
        };
    }

    render() {
      var classNom = "projectBox projectBox" + this.props.hoverColor;
      if(this.props.boxLink) {
        return (
          <a href={this.state.boxLink}>
            <div className={classNom}>
            <h2>{this.props.title}</h2>
            <p>{this.props.children}</p>
            </div>
          </a>
        );
      }
      else{ 
        return (
            <div className={classNom}>
              <h2>{this.props.title}</h2>
              <p>{this.props.children}</p>
            </div>
        );
      }
    }
  }

export { ProjectBox }; 